/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfilled_ShippedInputs */

const en_fulfilled_shipped = /** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulfilled / Shipped`)
};

const es_fulfilled_shipped = /** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completado / Enviado`)
};

const fr_fulfilled_shipped = /** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traité / Expédié`)
};

const de_fulfilled_shipped = /** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfüllt / Versendet`)
};

const id_fulfilled_shipped = /** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dipenuhi / Dikirim`)
};

/** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */
const ja_fulfilled_shipped = en_fulfilled_shipped;

/** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */
const zh_fulfilled_shipped = en_fulfilled_shipped;

/** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */
const ar_fulfilled_shipped = en_fulfilled_shipped;

/** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */
const it_fulfilled_shipped = en_fulfilled_shipped;

/** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */
const ru_fulfilled_shipped = en_fulfilled_shipped;

/** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */
const pt_fulfilled_shipped = en_fulfilled_shipped;

/** @type {(inputs: Fulfilled_ShippedInputs) => LocalizedString} */
const ko_fulfilled_shipped = en_fulfilled_shipped;

/**
* | output |
* | --- |
* | "Fulfilled / Shipped" |
*
* @param {Fulfilled_ShippedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfilled_shipped = /** @type {((inputs?: Fulfilled_ShippedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfilled_ShippedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfilled_shipped(inputs)
	if (locale === "es") return es_fulfilled_shipped(inputs)
	if (locale === "fr") return fr_fulfilled_shipped(inputs)
	if (locale === "de") return de_fulfilled_shipped(inputs)
	if (locale === "ja") return ja_fulfilled_shipped(inputs)
	if (locale === "zh") return zh_fulfilled_shipped(inputs)
	if (locale === "ar") return ar_fulfilled_shipped(inputs)
	if (locale === "id") return id_fulfilled_shipped(inputs)
	if (locale === "it") return it_fulfilled_shipped(inputs)
	if (locale === "ru") return ru_fulfilled_shipped(inputs)
	if (locale === "pt") return pt_fulfilled_shipped(inputs)
	return ko_fulfilled_shipped(inputs)
});